import {
  DELETE_LOGO,
  DELETE_LOGO_ERROR,
  DELETE_LOGO_REQUEST,
  DELETE_LOGO_SUCCESS,
  FETCH_LOGO,
  FETCH_LOGO_ERROR,
  FETCH_LOGO_REQUEST,
  FETCH_LOGO_SUCCESS,
  UPLOAD_LOGO,
  UPLOAD_LOGO_ERROR,
  UPLOAD_LOGO_REQUEST,
  UPLOAD_LOGO_SUCCESS,
} from "./constants";
import {
  IDeleteLogoAction,
  IFetchLogoAction,
  IUploadLogoAction,
} from "./types";

export const fetchLogo = (customerId: string): IFetchLogoAction => {
  return {
    type: FETCH_LOGO,
    payload: customerId,
  };
};

export const fetchLogoRequest = () => {
  return {
    type: FETCH_LOGO_REQUEST,
  };
};

export const fetchLogoSuccess = (payload?: {
  url?: string;
  dimensionWarnings?: string[];
}) => {
  return {
    type: FETCH_LOGO_SUCCESS,
    payload,
  };
};

export const fetchLogoError = (payload?: any) => {
  return {
    type: FETCH_LOGO_ERROR,
    payload,
  };
};

export const uploadLogo = (
  payload: IUploadLogoAction["payload"],
): IUploadLogoAction => {
  return {
    type: UPLOAD_LOGO,
    payload,
  };
};

export const uploadLogoRequest = () => {
  return {
    type: UPLOAD_LOGO_REQUEST,
  };
};

export const uploadLogoSuccess = (payload?: {
  url?: string;
  dimensionWarnings?: string[];
}) => {
  return {
    type: UPLOAD_LOGO_SUCCESS,
    payload,
  };
};

export const uploadLogoError = (payload?: any) => {
  return {
    type: UPLOAD_LOGO_ERROR,
    payload,
  };
};

export const deleteLogo = (
  payload: IDeleteLogoAction["payload"],
): IDeleteLogoAction => {
  return {
    type: DELETE_LOGO,
    payload,
  };
};

export const deleteLogoRequest = () => {
  return {
    type: DELETE_LOGO_REQUEST,
  };
};

export const deleteLogoSuccess = () => {
  return {
    type: DELETE_LOGO_SUCCESS,
  };
};

export const deleteLogoError = (payload?: any) => {
  return {
    type: DELETE_LOGO_ERROR,
    payload,
  };
};
